import { getBlockbusterRequestInstance } from '@/plugins/axios';
import MetadataModel from '@/models/MetadataModel';
import { MetadataResponse } from '@/types/blockbusterResponses';

const request = getBlockbusterRequestInstance();

export async function makeGetRequest(url: string): Promise<MetadataResponse> {
  const { data } = await request.get(url);

  return data;
}

export async function fetchMetadata(): Promise<MetadataResponse> {
  const { data } = await request.get('v1/metadata');

  return data;
}

export async function patchMetadata(id: string, fields: any): Promise<any> {
  const { data } = await request.patch(`/v1/metadata/${id}`, fields);

  return data;
}

export async function getSignedURL(filename: string): Promise<string> {
  const { data } = await request.get(`/v1/video/${filename}`);

  return data.url;
}

export default {
  makeGetRequest,
  patchMetadata,
  fetchMetadata,
  getSignedURL,
}
